import { render, staticRenderFns } from "./NegociacaoDiffDadosBasicos.vue?vue&type=template&id=1431190e"
import script from "./NegociacaoDiffDadosBasicos.vue?vue&type=script&lang=js"
export * from "./NegociacaoDiffDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports